export default "__VITE_ASSET__CjiVxCsG__"